import { defineMessages } from "./define";

/** The contract list, a contract's page, and uploading into a folder. */
export const contracts = defineMessages({
  ja: {
    "contracts.unfiled": "未分類",
    "contracts.loadingEllipsis": "読み込み中…",

    "contracts.list.title": "契約書",
    "contracts.list.count.one": "{count} 件",
    "contracts.list.count.other": "{count} 件",
    "contracts.list.extracting": "抽出中の契約書があります",
    "contracts.list.loadFailed": "一覧を取得できませんでした",
    "contracts.list.emptyTitle": "まだ契約書がありません",
    "contracts.list.emptyBody":
      "上のエリアから PDF をアップロードすると、ここに並びます。",
    "contracts.list.column.fileName": "ファイル名",
    "contracts.list.column.type": "種類",
    "contracts.list.column.counterparty": "相手方",
    "contracts.list.column.entity": "法人",
    "contracts.list.column.endDate": "終了日",
    "contracts.list.column.status": "状態",
    "contracts.list.column.uploadedAt": "アップロード",

    "contracts.upload.destination": "保存先フォルダ",
    "contracts.upload.requesting": "アップロード URL を発行しています…",
    "contracts.upload.uploading": "S3 に送信しています…",
    "contracts.upload.done":
      "{fileName} を「{folder}」にアップロードしました。抽出は自動で始まります。",
    "contracts.upload.notCancelled":
      "{reason} 登録の取り消しにも失敗したため、一覧に「アップロード済み」のまま残ります。",
    "contracts.upload.dropTitle": "契約書 PDF をアップロード",
    "contracts.upload.dropHint":
      "クリックして選択、またはここにドラッグ&ドロップ（PDF のみ・30 ページまで）。保存先: {folder}",
    "contracts.upload.notPdf":
      "PDF ファイルを選んでください。Word 形式は取り込めません。",

    "contracts.audience.always": "管理者チームとアップロードしたあなた",
    "contracts.audience.unfiled":
      "未分類に入れると、読めるのは{always}だけです。",
    "contracts.audience.noGrants":
      "このフォルダに入れても、読めるのは{always}だけです。",
    "contracts.audience.withGrants":
      "このフォルダに入れると、{always}に加えて次の相手が読めます: {names}",
    "contracts.audience.separator": "、",
    "contracts.audience.team": "{name}（チーム）",

    "contracts.detail.back": "一覧へ",
    "contracts.detail.notStated": "記載なし",
    "contracts.detail.loadFailed": "契約書を取得できませんでした",
    "contracts.detail.issuingUrl": "URL を発行中…",
    "contracts.detail.openPdf": "PDF を開く",
    "contracts.detail.discoverableTitle": "この契約書の PDF は閲覧できません",
    "contracts.detail.discoverableBody":
      "存在と抽出結果のみ参照できます。内容を確認する必要がある場合は、アップロードした担当者か管理者に閲覧権限を依頼してください。",
    "contracts.detail.failedTitle": "抽出に失敗しました",
    "contracts.detail.extracting":
      "抽出を実行しています。完了すると自動で表示が更新されます。",
    "contracts.detail.coverageTitle": "一部のページを読み取れていません",
    "contracts.detail.coverageBody":
      "{expected} ページ中 {detected} ページのみ読み取れています（未読取: {missing}）。抽出結果はこの範囲に基づきます。",
    "contracts.detail.folderSection": "フォルダ",
    "contracts.detail.folder": "保管先",
    "contracts.detail.extractedSection": "抽出結果",
    "contracts.detail.field.title": "タイトル",
    "contracts.detail.field.type": "種類",
    "contracts.detail.field.counterparty": "相手方",
    "contracts.detail.field.shortName": "略称",
    "contracts.detail.field.entity": "締結法人",
    "contracts.detail.field.amount": "契約金額",
    "contracts.detail.field.effectiveDate": "発効日",
    "contracts.detail.field.endDate": "終了日",
    "contracts.detail.field.autoRenewal": "自動更新",
    "contracts.detail.field.renewalTerm": "更新期間",
    "contracts.detail.field.noticePeriod": "通知期限",
    "contracts.detail.field.noticeDeadline": "通知の期日",
    "contracts.detail.field.lifecycle": "契約の状態",
    "contracts.detail.yes": "あり",
    "contracts.detail.no": "なし",
    "contracts.detail.pendingExtraction": "抽出が終わるとここに表示されます。",
    "contracts.detail.noExtraction": "抽出結果はありません。",
    "contracts.detail.fileSection": "ファイル情報",
    "contracts.detail.field.uploadedBy": "アップロード者",
    "contracts.detail.field.uploadedAt": "アップロード日時",
    "contracts.detail.field.pageCount": "ページ数",
    "contracts.detail.field.updatedAt": "最終更新",
    "contracts.detail.field.approvedBy": "承認者",
    "contracts.detail.field.approvedAt": "承認日時",

    "contracts.review.title": "抽出結果はまだ確認されていません",
    "contracts.review.body":
      "AI が読み取った内容です。PDF と照らし合わせ、誤りがあれば直してから承認してください。空欄にした項目は「記載なし」として保存されます。",
    "contracts.review.invalid": "赤枠の項目を確認してください。",
    "contracts.review.failed": "承認できませんでした",
    "contracts.review.currency": "通貨（JPY など）",
    "contracts.review.renewalTermMonths": "更新期間（月）",
    "contracts.review.noticePeriodDays": "通知期限（日）",
    "contracts.review.derivedDeadline":
      "通知の期日は終了日と通知期限から自動で計算されます: {deadline}",
    "contracts.review.submit": "この内容で承認",
    "contracts.review.submitting": "承認しています…",

    "contracts.tracker.unknownEntity": "不明",
    "contracts.tracker.otherType": "その他",
  },
  en: {
    "contracts.unfiled": "Unfiled",
    "contracts.loadingEllipsis": "Loading…",

    "contracts.list.title": "Contracts",
    "contracts.list.count.one": "{count} item",
    "contracts.list.count.other": "{count} items",
    "contracts.list.extracting": "Some contracts are being extracted",
    "contracts.list.loadFailed": "Could not load the contracts",
    "contracts.list.emptyTitle": "No contracts yet",
    "contracts.list.emptyBody":
      "Upload a PDF in the area above and it will appear here.",
    "contracts.list.column.fileName": "File name",
    "contracts.list.column.type": "Type",
    "contracts.list.column.counterparty": "Other party",
    "contracts.list.column.entity": "Entity",
    "contracts.list.column.endDate": "End date",
    "contracts.list.column.status": "Status",
    "contracts.list.column.uploadedAt": "Uploaded",

    "contracts.upload.destination": "Destination folder",
    "contracts.upload.requesting": "Requesting an upload URL…",
    "contracts.upload.uploading": "Sending to S3…",
    "contracts.upload.done":
      "Uploaded {fileName} to “{folder}”. Extraction starts automatically.",
    "contracts.upload.notCancelled":
      "{reason} Cancelling the registration also failed, so it stays in the list as “Uploaded”.",
    "contracts.upload.dropTitle": "Upload a contract PDF",
    "contracts.upload.dropHint":
      "Click to choose, or drag and drop here (PDF only, up to 30 pages). Destination: {folder}",
    "contracts.upload.notPdf":
      "Choose a PDF file. Word documents cannot be imported.",

    "contracts.audience.always":
      "the administrators team and you (the uploader)",
    "contracts.audience.unfiled": "If left unfiled, only {always} can read it.",
    "contracts.audience.noGrants": "In this folder, only {always} can read it.",
    "contracts.audience.withGrants":
      "In this folder, besides {always}, these can read it: {names}",
    "contracts.audience.separator": ", ",
    "contracts.audience.team": "{name} (team)",

    "contracts.detail.back": "Back to list",
    "contracts.detail.notStated": "Not stated",
    "contracts.detail.loadFailed": "Could not load the contract",
    "contracts.detail.issuingUrl": "Issuing URL…",
    "contracts.detail.openPdf": "Open PDF",
    "contracts.detail.discoverableTitle": "You cannot view this contract's PDF",
    "contracts.detail.discoverableBody":
      "Only its existence and extracted details are visible to you. If you need to read it, ask the uploader or an administrator for view access.",
    "contracts.detail.failedTitle": "Extraction failed",
    "contracts.detail.extracting":
      "Extraction is running. This page updates automatically when it finishes.",
    "contracts.detail.coverageTitle": "Some pages could not be read",
    "contracts.detail.coverageBody":
      "Only {detected} of {expected} pages were read (unread: {missing}). The extracted details are based on those pages.",
    "contracts.detail.folderSection": "Folder",
    "contracts.detail.folder": "Location",
    "contracts.detail.extractedSection": "Extracted details",
    "contracts.detail.field.title": "Title",
    "contracts.detail.field.type": "Contract Type",
    "contracts.detail.field.counterparty": "Other Party",
    "contracts.detail.field.shortName": "Short Name",
    "contracts.detail.field.entity": "Soracom Entity",
    "contracts.detail.field.amount": "Contract Value",
    "contracts.detail.field.effectiveDate": "Start Date",
    "contracts.detail.field.endDate": "Expiration Date",
    "contracts.detail.field.autoRenewal": "Auto-renewal",
    "contracts.detail.field.renewalTerm": "Renewal Period",
    "contracts.detail.field.noticePeriod": "Notification Deadline",
    "contracts.detail.field.noticeDeadline": "Notice due date",
    "contracts.detail.field.lifecycle": "Contract Status",
    "contracts.detail.yes": "Yes",
    "contracts.detail.no": "No",
    "contracts.detail.pendingExtraction":
      "Details will appear here once extraction finishes.",
    "contracts.detail.noExtraction": "No extracted details.",
    "contracts.detail.fileSection": "File",
    "contracts.detail.field.uploadedBy": "Uploaded by",
    "contracts.detail.field.uploadedAt": "Uploaded at",
    "contracts.detail.field.pageCount": "Pages",
    "contracts.detail.field.updatedAt": "Last updated",
    "contracts.detail.field.approvedBy": "Approved by",
    "contracts.detail.field.approvedAt": "Approved at",

    "contracts.review.title": "Nobody has checked these details yet",
    "contracts.review.body":
      'This is what the AI read. Compare it with the PDF, correct anything wrong, then approve. A field left empty is saved as "Not stated".',
    "contracts.review.invalid": "Check the highlighted fields.",
    "contracts.review.failed": "Could not approve",
    "contracts.review.currency": "Currency (e.g. JPY)",
    "contracts.review.renewalTermMonths": "Renewal term (months)",
    "contracts.review.noticePeriodDays": "Notice period (days)",
    "contracts.review.derivedDeadline":
      "The notice deadline is worked out from the end date and the notice period: {deadline}",
    "contracts.review.submit": "Approve these details",
    "contracts.review.submitting": "Approving…",

    "contracts.tracker.unknownEntity": "Unknown",
    "contracts.tracker.otherType": "Other",
  },
});
